import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ArticleTitle from "../components/Article/ArticleTitle";
import ArticleWrapper from "../components/Article/Wrapper";
import Branches from "../components/Branches";
import Deparataments from "../components/Departaments";
import { usePageContext } from "../utils/PageContext";

import "../styles/contact.scss";
import ApplicationsDownloadBanner from "../components/ApplicationsDownloadBanner";
import Breadcrumbs from "../components/Breadcrumbs";
import Paragraph from "../components/Article/Paragraph";
import { useStaticQuery } from "gatsby";

export default function Contact() {
  const apiData = useStaticQuery(query);
  const social = apiData.api.configSocialMediaAndApp;
  const contact = apiData.api.configContact;

  const { changeArticleType, lang } = usePageContext();
  const { t } = useTranslation();

  // useEffect(() => {
  //   changeArticleType("INDIVIDUAL");
  // }, []);

  const categories = {
    title: {
      text_sq: t("pages.contact.label"),
      text_en: t("pages.contact.label"),
    },
    slug: "contact",
  };

  return (
    <>
      <div className="wrapper">
        <Breadcrumbs data={categories} />
      </div>
      <ArticleTitle
        data={{
          title: {
            text_sq: t("contactPage.header.title"),
            text_en: t("contactPage.header.title"),
          },
        }}
      />
      <section class="wrapper bg-light">
        <div class="container pb-14 pb-md-16">
          <div class="row">
            <div class="col-lg-12 mx-auto">
              <div class="blog single mt-n17">
                <div className="card">
                  <div className="row gx-0">
                    <div className="col-lg-6 align-self-stretch">
                      <div className="map map-full rounded-top rounded-lg-start">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2995.829883970267!2d19.79278571556021!3d41.33431240724644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135031e0848900d1%3A0x651c5d18764b6924!2sShkolla%20e%20Magjistratur%C3%ABs!5e0!3m2!1sen!2s!4v1629964050225!5m2!1sen!2s"
                          style={{ width: "100%", height: "100%", border: "0" }}
                          allowfullscreen=""
                          loading="lazy"
                        ></iframe>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="p-10 p-md-11 p-lg-14">
                        <div className="d-flex flex-row">
                          <div>
                            <div className="icon text-primary fs-28 me-4 mt-n1">
                              <i className="uil uil-location-pin-alt"></i>
                            </div>
                          </div>
                          <div className="align-self-start justify-content-start">
                            <h5 className="mb-1">
                              {t("contact.labels.address")}
                            </h5>
                            <address>
                              <Paragraph
                                data={{
                                  text_sq: t("contact.address"),
                                  text_en: t("contact.address"),
                                }}
                              />
                            </address>
                          </div>
                        </div>
                        <div className="d-flex flex-row">
                          <div>
                            <div className="icon text-primary fs-28 me-4 mt-n1">
                              <i className="uil uil-phone-volume"></i>
                            </div>
                          </div>
                          <div>
                            <h5 className="mb-1">
                              {t("contact.labels.phone")}
                            </h5>
                            <p>
                              <a
                                href={`tel:${contact.phoneNumber}`}
                                className="link-body"
                              >
                                {contact.phoneNumber}
                              </a>
                            </p>
                            <p>
                              <a
                                href={`tel:+355 42 46 88 25`}
                                className="link-body"
                              >
                                +355 42 46 88 25 ({t("contact.registrarOffice")}
                                )
                              </a>
                            </p>
                          </div>
                        </div>
                        <div className="d-flex flex-row">
                          <div>
                            <div className="icon text-primary fs-28 me-4 mt-n1">
                              <i className="uil uil-envelope"></i>
                            </div>
                          </div>
                          <div>
                            <h5 className="mb-1">
                              {t("contact.labels.email")}
                            </h5>
                            <p className="mb-0">
                              <a
                                href={`mailto:${contact.email}`}
                                className="link-body"
                              >
                                {contact.email}
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <center>
          <h1>Kontaktoni me ne</h1>
        </center>
        <br />
      </section>
      <section>
        <div className="form-contact-js">
          <form
            action="https://formsubmit.co/info@magjistratura.edu.al"
            method="POST"
          >
            <input type="text" name="Emri" placeholder="Emri" required />
            <br />
            <br />
            <input type="text" name="Mbiemri" placeholder="Mbiemri" required />
            <br />
            <br />
            <input type="email" name="Email" placeholder="Email" required />
            <label htmlFor="subjekti" name="Subjekti">
              Subjekti (Kliko për të parë opsionet)
            </label>
            <select name="Subjekti" id="subjekti">
              <option value="Kërkesë për informacion">
                Kërkesë për informacion
              </option>
              <option value="Ndihmë në mbarëvajtjen e punimeve në shkollë">
                Ndihmë në mbarëvajtjen e punimeve në shkollë
              </option>
            </select>
            <br />
            <br />
            <textarea
              id="Mesazhi"
              name="Mesazhi"
              placeholder="Mesazhi"
              rows="4"
              cols="30"
              required
            ></textarea>
            <br />
            <br />
            <button type="submit" className="button1">
              Dërgo
            </button>
            <input
              type="hidden"
              name="_next"
              defaultValue="https://magjistratura.edu.al/sq/contact"
            />
            <br />
            <br />
          </form>
        </div>
      </section>
    </>
  );
}

export const query = graphql`
  query {
    api {
      configSocialMediaAndApp {
        facebookUrl
        androidUrl
        instagramUrl
        iosUrl
        linkedinUrl
        twitterUrl
        youtubeUrl
      }

      configContact {
        phoneNumber
        tollFree
        email
      }
    }
  }
`;
